import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import BrieConversationAPI from "../../api/BrieConversationAPI";

interface DeleteConvoProps {
  conversationID: string;
}

const useDeleteConversation = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const useDeleteConversation = useMutation({
    mutationFn: ({ conversationID }: DeleteConvoProps) => {
      return BrieConversationAPI.deleteGPTConversation(conversationID);
    },
    onMutate: ({ conversationID }: DeleteConvoProps) => {
      queryClient.setQueryData(["conversations-gpt", tenantID], (prev) => {
        if (!Array.isArray(prev)) return prev;

        return prev.filter((c) => c.id !== conversationID);
      });
    },
  });

  return {
    deleteConversation: useDeleteConversation.mutate,
    deletingConversation: useDeleteConversation.isPending,
    deleteConvoError: useDeleteConversation.error
      ? getErrorMessage(useDeleteConversation.error)
      : null,
  };
};

export default useDeleteConversation;
